export default {
  input: {
    '&:not(:last-child)': {
      marginRight: 16,
    },
  },
};
